<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-roles-role-dialog-create
          v-if="$hasPermissionTo(['create roles'])"
          @created="loadData"
        />
      </v-col>
    </v-row>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="roles"
      :sort-by.sync="sortBy"
      :items-per-page="itemsPerPage"
      item-key="id"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.level }}</td>
          <td>{{ props.item.name }}</td>
          <td>
            <setup-roles-role-dialog-edit
              v-if="$hasPermissionTo(['update roles'])"
              :role="props.item" 
              @updated="loadData"
            />
            <setup-roles-role-dialog-delete
              v-if="$hasPermissionTo(['delete roles'])"
              :role="props.item"
              @deleted="loadData"
            />
            <span class="mx-1" />
            <setup-roles-role-sidebar-form-edit
              v-if="$hasPermissionTo(['view configuration roles'])"
              :role="props.item"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupRolesRoleDialogEdit: () => import('@/components/hris/setup/roles/role/DialogEdit'),
      SetupRolesRoleDialogCreate: () => import('@/components/hris/setup/roles/role/DialogCreate'),
      SetupRolesRoleDialogDelete: () => import('@/components/hris/setup/roles/role/DialogDelete'),
      SetupRolesRoleSidebarFormEdit: () => import('@/components/hris/setup/roles/role/SidebarFormEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Rank',
            align: 'left',
            value: 'level',
          },
          {
            text: 'Role Name',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: '',
          },
        ],
        itemsPerPage: 10,
        sortBy: 'level',
        roles: [],
        loading: false,
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.hrisRoles().list()
          .then(res => {
            this.roles = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-table__overflow{
    overflow-x: hidden;
  }
</style>
